import { render, staticRenderFns } from "./add_customer.vue?vue&type=template&id=33bcc56e&"
import script from "./add_customer.vue?vue&type=script&lang=js&"
export * from "./add_customer.vue?vue&type=script&lang=js&"
import style0 from "./add_customer.vue?vue&type=style&index=0&id=33bcc56e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports